// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + ".js?id=" + {"65":"9f5bfadcfa30a114","856":"e83cc51e2161006e"}[chunkId] + "";
};